export default {
  responses: [],
  sortResponses() {
    this.responses.sort((a, b) => {
      a.id - b.id;
    });
  },

  setResponse(id, points, category) {
    localStorage.setItem('updated', true);
    const qindex = this.responses.findIndex((r) => r.id === id);
    if (qindex === -1) {
      this.responses.push({ id, points, category });
      return;
    }
    this.responses[qindex].points = points;
  },

  delResponse(id) {
    const qindex = this.responses.findIndex((r) => r.id === id);
    if (qindex > -1) {
      this.responses.splice(qindex, 1);
    }
  },

  getFilled() {
    return this.responses.map((r) => r.id);
  },

  getScore() {
    if (localStorage.getItem('updated')) {
      const tabulated = {};
      for (let i = 0; i < this.responses.length; i++) {
        if (tabulated[this.responses[i].category]) {
          tabulated[this.responses[i].category] += this.responses[i].points;
        } else {
          tabulated[this.responses[i].category] = this.responses[i].points;
        }
      }
      localStorage.setItem('score', tabulated);
      localStorage.setItem('updated', false);
      return tabulated;
    }
    return localStorage.getItem('score');
  },

  resetStore() {
    this.responses = [];
  },
};
